import { render, staticRenderFns } from "./CardCalculator.vue?vue&type=template&id=0d264c8b&scoped=true"
import script from "./CardCalculator.vue?vue&type=script&lang=ts"
export * from "./CardCalculator.vue?vue&type=script&lang=ts"
import style0 from "./CardCalculator.vue?vue&type=style&index=0&id=0d264c8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d264c8b",
  null
  
)

export default component.exports